import { makeStyles } from "@material-ui/core";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
    // paddingTop: theme.spacing(8),
  },
  tabs: {
    marginBottom: theme.spacing(2),

    "& .MuiButton-root": {
      marginRight: theme.spacing(2)
    }
  },
  alphaButton: {
    backgroundColor: theme.palette.primary.opacity,
    color: theme.palette.primary.main,

    "&:hover": {
      backgroundColor: theme.palette.primary.opacity2
    }
  },
  drawerPaper: {
    width: drawerWidth,
    position: "fixed",
    top: theme.spacing(8),
    borderRight: "none",
    zIndex: "1"
  },
  content: {
    flexGrow: 1,
    boxSizing: "border-box",
    padding: theme.spacing(3),
    width: `calc( 100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  titleSection: {
    marginBottom: "24px !important",
    marginTop: "32px !important",
    "& h4": {
      marginBottom: "16px !important"
    }
  },
  tableAction: {
    position: "absolute",
    right: 16,
    top: 16
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& .MuiIconButton-root": {
      marginRight: theme.spacing(1)
    }
  },
  tableSection: {
    marginTop: "20px !important",
    "& .MuiTypography-h6": {
      marginBottom: "24px !important"
    },
    "& .mdl-data-table": {
      textAlign: "center",
      "& tr th": {
        paddingLeft: "80px !important",
        paddingRight: "80px !important",
        textAlign: "center !important"
      },
      "& tr td": {
        paddingLeft: "60px !important",
        paddingRight: "60px !important",
        textAlign: "center !important"
      },
      "& .name-rename-first-column": {
        paddingRight: "0 !important"
      },
      "& tbody tr td a": {
        marginTop: "0 !important"
      },
      "& .MuiInput-underline.Mui-disabled:before": {
        borderBottom: "none !important"
      },
      "& .permission-remove-column": {
        paddingLeft: "0 !important"
      }
    },
    "& .reset-margin-top-table": {
      marginTop: "0 !important"
    },
    "& .table-button-wrap": {
      position: "relative",
      marginLeft: "24px !important"
    },
    "& .MuiFormControl-root": {
      width: "100% !important"
    },
    "& .MuiInputBase-input": {
      width: "100% !important",
      textAlign: "center",
      color: "#000",
      fontSize: "16px !important"
    }
  },
  flex: {
    display: "flex !important"
  },
  // styledSubmitBtnWrap: {
  //   marginTop: theme.spacing(2),
  // },
  renameInput: {
    "& .MuiInput-underline:after": {
      borderBottom: "2px solid #00afc6 !important"
    }
  },
  removeBtn: {
    "& .MuiButton-containedPrimary": {
      width: "140px !important",
      lineHeight: "2em !important"
    }
  },
  input: {
    marginRight: 15
  }
}));

export default useStyles;
